import { Component, OnInit } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { FuseConfigService } from '../../core/services/config.service';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from  '../../core/services/user.service';

import * as firebase from 'firebase/app';

@Component({
    selector   : 'fuse-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls  : ['./toolbar.component.scss']
})

export class FuseToolbarComponent
{
    userStatusOptions: any[];
    languages: any;
    selectedLanguage: any;
    showLoadingBar: boolean;
    horizontalNav: boolean;
    loggedInUser: any;
    app_section: string = "";

    constructor(
        private router: Router,
        private fuseConfig: FuseConfigService,
        private translate: TranslateService,
        private userService: UserService
    )
    {
      
        this.userStatusOptions = [
            {
                'title': 'Online',
                'icon' : 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon' : 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon' : 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];

        this.languages = [
            {
                'id'   : 'en',
                'title': 'English',
                'flag' : 'us'
            },
            {
                'id'   : 'tr',
                'title': 'Turkish',
                'flag' : 'tr'
            }
        ];

        this.selectedLanguage = this.languages[0];

        router.events.subscribe(
            (event) => {
                if ( event instanceof NavigationStart )
                {
                    this.showLoadingBar = true;
                }
                if ( event instanceof NavigationEnd )
                {
                    this.showLoadingBar = false;

                    // We should make this more elegant 
                    let u = window.location.href.toLowerCase();

                    if (u.indexOf('/landing') > 0)
                        this.app_section = "Main Menu";
                    if (u.indexOf('/surgery-type') > 0 )
                        this.app_section = "Pre-Surgery";
                    if (u.indexOf('/upload-data') > 0 )
                        this.app_section = "Upload Patient Data";
                    if (u.indexOf('/latest') > 0 )
                        this.app_section = "Post-Surgery";
                    if (u.indexOf('/me') > 0 )
                        this.app_section = "View Reports";
                    if (u.indexOf('/compare') > 0 )
                        this.app_section = "Compare Reports";
                    if (u.indexOf('/contact') > 0 )
                        this.app_section = "Contact Us";
                    if (u.indexOf('/Help') > 0 )
                        this.app_section = "Help";

                    if (u.indexOf('auth') > 0 )
                        this.app_section = "";
                }
            });

        this.fuseConfig.onSettingsChanged.subscribe((settings) => {
            this.horizontalNav = settings.layout.navigation === 'top';
        });

    }

    enforceLogin() {
        let u = window.location.href.toLowerCase();

        if (u.indexOf('pages/auth') < 0 && u.indexOf('pages/info') <0 )
        {
            console.log("Login Required... Enforcing login");
            if (this.loggedInUser == null) {
                console.log("No logged in user detected. Redirecting to /pages/auth/login")
                this.router.navigate(['/pages/auth/login']);
            } else {
                console.log("Login status: OK");
            }
        } else {
            console.log("Login Not Required")
        }
    }
    logout() {
        this.userService.logout();
        //this.router.navigate(['/pages/auth/login']);
    }

    //Load landing page if logged in
    goHome() {
        if (this.loggedInUser != null)
            this.router.navigate(['/landing']) //TODO: use a router guard
        else
            this.router.navigate(['/pages/auth/login']);
    }

    search(value)
    {
        // Do your search here...
        console.log(value);
    }

    setLanguage(lang)
    {
        // Set the selected language for toolbar
        this.selectedLanguage = lang;

        // Use the selected language for translations
        this.translate.use(lang.id);
    }
    ngOnInit() {
        this.userService.afAuth.authState.subscribe((auth) => {
            this.loggedInUser = auth;
            this.enforceLogin();
        })
    }
}



// WEBPACK FOOTER //
// C:/Users/Marion Surgical/Desktop/Sean/marion-surgical-master/src/app/main/toolbar/toolbar.component.ts